/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} True_Rosy_Bear_TrotInputs */

const en_true_rosy_bear_trot = /** @type {(inputs: True_Rosy_Bear_TrotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lastname`)
};

const de_true_rosy_bear_trot = /** @type {(inputs: True_Rosy_Bear_TrotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname`)
};

/**
* | output |
* | --- |
* | "Lastname" |
*
* @param {True_Rosy_Bear_TrotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const true_rosy_bear_trot = /** @type {((inputs?: True_Rosy_Bear_TrotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<True_Rosy_Bear_TrotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_true_rosy_bear_trot(inputs)
	return de_true_rosy_bear_trot(inputs)
});